import { Component, Input, Optional, Self, TemplateRef, ViewChild, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule, NgControl } from '@angular/forms';

import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzConfigService } from 'ng-zorro-antd/core/config';

import { AppIcons } from '@core/utilities/icons';


@Component({
  selector: 'app-core-select',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    NzSelectModule,
    NzFormModule,
    FontAwesomeModule
  ],
  templateUrl: './core-select.component.html',
  styleUrl: './core-select.component.scss',
  // providers: [
  //   {
  //     provide: NG_VALUE_ACCESSOR,
  //     useExisting: forwardRef(() => CoreSelectComponent),
  //     multi: true
  //   }
  // ]
})
export class CoreSelectComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() options: { name: string, id: any }[] = [];
  @Input() placeholder: string = 'Selecciona una opción';
  @Input() helperText: string = '';
  @Input() errorMessages: Record<string, string> = {};
  @Input() isError: boolean = false;

  value: any = null;
  disabled: boolean = false;

  icons: typeof AppIcons = AppIcons;

  onChange: any = () => { };
  onTouched: any = () => { };

  @ViewChild('iconSelect', { static: true })
  nzSuffixIcon!: TemplateRef<void>;

  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private readonly nzConfigService: NzConfigService
  ) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.nzConfigService.set('select', { nzSuffixIcon: this.nzSuffixIcon, nzBackdrop: true });
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  getErrorMessage(key: any): string | undefined {
    return this.errorMessages[key as string];
  }

  get showError(): boolean {
    const control = this.ngControl?.control;
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  get showHelper(): boolean {
    return !!(this.helperText && !this.showError);
  }
}
